import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { GlobalStateService } from "../services/global-state.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  private router = inject(Router);
  private globalStateSvc = inject(GlobalStateService);
  private translateSvc = inject(TranslateService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    if (this.globalStateSvc.isAuthenticated) {
      this.translateSvc.use(this.globalStateSvc.langNameID);
      return true;
    } else {
      this.router.navigate(["login"], { queryParams: route.queryParams });
      return false;
    }
  }
}
